<template>
  <v-sheet color="#e3191c" class="white--text text-justify">
    <v-container v-bind="propsPageContainer">
      <v-row v-bind="propsPageMainRow">
        <v-col v-bind="propsPageMainCol">
          <h1 v-bind="propsPageTitle">Les Voltes</h1>
          <v-card
            v-bind="propsPrimaryCard"
            color="#e3191c"
            class="font-weight-bold white--text"
            data-cy="promotions-les-voltes-oct-2020"
          >
            <v-container>
              <v-row v-bind="propsRows">
                <v-col cols="12" md="8" lg="6">
                  <div class="mb-2">
                    La Llibreria Les Voltes t'obsequiarà un dels llibres dels
                    presos i exiliats per cadascuna de les persones que convidis
                    a formar part del Consell de la República Catalana i que es
                    registrin i es subscriguin.
                  </div>
                  <div class="mb-2">
                    El llibre s'enviarà a la direcció que consta al teu perfil
                    ciutadà. En cas que hagis d'actualitzar la direcció, si us
                    plau, fes-ho abans de reclamar la promoció.
                  </div>
                </v-col>
              </v-row>

              <v-item-group v-model="editBookChoice" mandatory>
                <div v-for="(book, i) in books" :key="i">
                  <v-item v-slot="{ active, toggle }">
                    <v-sheet
                      :color="active ? 'primary' : 'transparent'"
                      class="white--text"
                      @click="toggle"
                    >
                      <v-row v-bind="propsRows">
                        <v-col
                          v-bind="propsCols"
                          :order-sm="i % 2 ? 'last' : 'first'"
                        >
                          <v-btn
                            fab
                            absolute
                            color="#e3191c"
                            class="white--text"
                          >
                            <v-icon>
                              {{
                                active
                                  ? "mdi-checkbox-marked-outline"
                                  : "mdi-checkbox-blank-outline"
                              }}
                            </v-icon>
                          </v-btn>
                          <v-img
                            contain
                            :max-height="bookImgHeight"
                            :src="`${publicPath}extras/${book.image}`"
                          ></v-img>
                        </v-col>
                        <v-col v-bind="propsCols"
                          ><div v-html="book.description"></div
                        ></v-col>
                      </v-row>
                    </v-sheet>
                  </v-item>
                </div>

                <v-row v-bind="propsRows">
                  <v-col cols="12" md="8" lg="6">
                    <v-alert type="info" color="#000">
                      Escull i sel·lecciona el llibre que vulguis de la llista
                      anterior, prem el botó de reclamar la promoció i s'enviarà
                      una notificació a la Llibreria Les Voltes, en uns dies
                      rebràs a la direcció que consta ara mateix al teu perfil
                      el llibre escollit.
                    </v-alert>
                  </v-col>
                </v-row>

                <div class="pa-4 d-flex">
                  <div class="flex-grow-1"></div>
                  <v-btn
                    v-bind="propsButtonAction"
                    :disabled="!formReadyForSubmit"
                    data-cy="button-send"
                    @click="send"
                    >Reclamar promoció</v-btn
                  >
                  <div class="flex-grow-1"></div>
                </div>

                <v-row v-bind="propsRows">
                  <v-col cols="12" md="8" lg="6"
                    ><v-img
                      contain
                      :src="`${publicPath}extras/LesVoltesOct2020Imgs/logo.png`"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-item-group>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import moment from "moment";
import LesVoltesOct2020Books from "@/modules/extras/rewards/LesVoltesOct2020Books.mixin";

export default {
  name: "LesVoltesOct2020RewardPage",
  mixins: [LesVoltesOct2020Books],
  data: () => ({
    editBookChoice: 0,

    bookImgHeight: 250,

    propsRows: {
      justify: "center",
      class: "pa-8"
    },
    propsCols: {
      cols: "12",
      sm: "6",
      md: "4",
      lg: "3"
    }
  }),
  computed: {
    objectId() {
      let objectId = "";
      if (this.$route.params.id) {
        objectId = this.$route.params.id.toString();
      }
      return objectId;
    },
    formReadyForSubmit() {
      if (!this.isRewardActive("LesVoltesNov2020")) {
        return false;
      }
      return true;
    },
    user() {
      return this.$store.getters["users/readById"](this.objectId);
    }
  },
  methods: {
    isRewardActive(idReward) {
      let active = false;

      if (this.user && this.user.rewards && Array.isArray(this.user.rewards)) {
        for (let i = 0; i < this.user.rewards.length; i++) {
          if (
            this.user.rewards[i].promotionCode &&
            this.user.rewards[i].promotionCode === idReward &&
            this.user.rewards[i].redeemedAt &&
            this.user.rewards[i].redeemedAt === -1
          ) {
            if (this.user.rewards[i].expiry) {
              let expiry = moment(this.user.rewards[i].expiry);
              if (moment().isBefore(expiry)) {
                active = true;
              }
            }
          }
        }
      }

      return active;
    },
    send() {
      console.log("send", this.books[this.editBookChoice]);
      // TODO: despres d'enviar la notificació s'ha de refrescar la info de
      // l'usuari perquè quedi marcat que ja ha agafat aquesta promoció.
    }
  }
};
</script>
